import dataBeleidNietErnstigDoac from "../../../../src/data/niet-ernstige-bloedingen-onder-doac.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBeleidNietErnstigDoac,
  BasicCollapse,
  React
};